import {
    ComponentWithSkeleton,
    IncompleteSkeletonComponent,
    SkeletonComponent,
} from '@hh.ru/magritte-ui-skeleton/types';

export const enrichWithSkeleton = <BaseComponent extends React.ComponentType<BaseComponentProps>, BaseComponentProps>(
    Component: BaseComponent,
    IncompleteSkeleton: IncompleteSkeletonComponent<BaseComponentProps>
): ComponentWithSkeleton<BaseComponent, BaseComponentProps> => {
    const ComponentWithSkeleton = Component as ComponentWithSkeleton<BaseComponent, BaseComponentProps>;

    const Skeleton: SkeletonComponent<BaseComponentProps> = (props) => (
        <IncompleteSkeleton {...props} Component={Component} />
    );

    ComponentWithSkeleton.Skeleton = Skeleton;

    return ComponentWithSkeleton;
};
